<template>
    <v-autocomplete
        v-model="inputedValue"
        :items="items"
        v-on:click:clear="$emit('click:clear')"
        clearable
        multiple
        outlined
        background-color="white"
        small-chips
        item-color
        hide-details
        class="text-select"
        :item-text="itemText"
        :item-value="itemValue"
        :return-object="returnObject"
    ></v-autocomplete>
</template>

<script>
export default {
  props: {
    value: Array,
    items: Array,
    itemText: String,
    itemValue: String,
    returnObject: {
        type: Boolean,
        default: false,
    },
  },
  computed: {
    inputedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
<style scoped lang="scss">
.text-select ::v-deep .v-input__icon {
    height: 25px !important;
}
.text-select ::v-deep .v-select__selections{
    margin-top: 5px;
    margin-bottom: 5px;
    min-height: 26px!important;
}
.text-select ::v-deep .v-chip.v-size--small {
    border-radius: 8px;
    font-size: 9px;
    height: 16px;
    margin: 2px;
}
.text-select ::v-deep .v-input__slot{
    min-height: 36px !important;
}

.text-select ::v-deep .v-input__slot input{
    padding:0px !important;
}

.text-select ::v-deep .v-input__append-inner{
    margin-top: 4px;
}
.text-select ::v-deep input{
    font-size: 13px !important;
}
::v-deep .v-list-item__content{
    padding:0px!important;
}
::v-deep .v-list-item__content .v-list-item__title {
    font-size: 1.2rem !important;
}
::v-deep .v-list-item__action{
    margin-right: 5px!important;
    margin-top: 0px!important;
    margin-bottom: 0px!important;
}
::v-deep .v-list-item--highlighted{
    min-height: 32px!important;
    padding-left: 8px!important;
}
::v-deep .v-list-item {
    min-height: 32px!important;
    padding-left: 8px!important;
}
.v-select.v-input--dense .v-chip {
    margin: 5px !important;
}
::v-deep .v-list-item__icon {
    margin-top: 9px;
}
::v-deep .icon-item .v-list-item__icon{
    margin-left: 0px !important;
}
</style>